import { useRef, useState, useLayoutEffect, useMemo } from 'react';
import { Paper, Box, Typography, Chip as MUIChip } from '@mui/material';
import categoryBenefitsMap from '../../utils/categoryBenefitsMap';

const BenefitTiles = ({ benefits }) => {
  const { allPills, duplicates } = useMemo(() => {
    const featured = Array.isArray(benefits)
      ? benefits.filter((b) => b.featured)
      : [];
    const counts = featured.reduce((acc, obj) => {
      acc[obj.category] = (acc[obj.category] || 0) + 1;
      return acc;
    }, {});
    const totalDuplicates = Object.values(counts).reduce(
      (sum, c) => sum + (c > 1 ? c - 1 : 0),
      0
    );
    const pills = [];
    Object.entries(categoryBenefitsMap).forEach(([cat, { icon, label }]) => {
      if (featured.some((b) => b.category === cat)) {
        pills.push({ icon, label });
      }
    });
    if (featured.length < 4) {
      pills.push({ icon: '📝', label: 'Add to Resume' });
    }
    return { allPills: pills, duplicates: totalDuplicates };
  }, [benefits]);
  const pillsContainerRef = useRef(null);
  const [renderedPills, setRenderedPills] = useState(allPills);

  useLayoutEffect(() => {
    const container = pillsContainerRef.current;
    if (!container) {
      setRenderedPills(allPills);
      return;
    }
    const chips = Array.from(container.children);
    if (!chips.length) {
      setRenderedPills(allPills);
      return;
    }
    const GAP = 8;
    const firstH = chips[0].getBoundingClientRect().height;
    const rowHeight = firstH + GAP;
    const maxHeight = rowHeight * 4; 
    let visibleCount = 0;
    for (let chip of chips) {
      const bottom = chip.offsetTop - container.offsetTop + chip.offsetHeight;
      if (bottom <= maxHeight) visibleCount++;
      else break;
    }
    let newList;
    if (allPills.length > visibleCount) {
      const overflowCount = allPills.length - (visibleCount - 1);
      newList = [
        ...allPills.slice(0, visibleCount - 1),
        { icon: '+', label: `${overflowCount + duplicates} more` },
      ];
    } else {
      newList = allPills.slice();
      if (duplicates > 0) {
        newList.push({ icon: '+', label: `${duplicates} more` });
      }
    }
    const same =
      newList.length === renderedPills.length &&
      newList.every((p, i) => p.label === renderedPills[i]?.label);
    if (!same) {
      setRenderedPills(newList);
    }
  }, [allPills, duplicates]);

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <Paper
        elevation={1}
        sx={{
          height: '100%',
          // display: 'flex',
          // flexDirection: 'column',
          // justifyContent: 'space-between',
          padding: '16px',
          borderRadius: '12px',
          textAlign: 'left',
          mb: '20px',
          width: '100%',
          boxShadow: 'none',
        }}
      >
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: '150%',
            marginBottom: '8px',
            color: '#4D586F',
          }}
        >
          Benefits & Perks:
        </Typography>
        {renderedPills.length > 0 ? (
          <Box
            ref={pillsContainerRef}
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'left',
              gap: 1,
              maxWidth: '100%',
              // width: '500px',
              // height: '120px',
              boxSizing: 'border-box',
              mb: 1,
              // mx: '-10px',
              maxHeight: '150px',
              // overflow: 'hidden',
              // backgroundColor: '#f3f4f6',
            }}
          >
            {renderedPills.map((pill) => (
              <MUIChip
                key={pill.label}
                size="small"
                icon={<span style={{ fontSize: 13 }}>{pill.icon}</span>}
                label={pill.label}
                sx={{
                  fontSize: '12px',
                  fontWeight: 500,
                  px: '12px',
                  py: '15px',
                  borderRadius: '1em',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  backgroundColor: '#f3f4f6',
                }}
                aria-label={pill.label}
              />
            ))}
          </Box>
        ) : (
          <Typography sx={{ fontSize: '14px', color: '#646D7A' }}>
            No benefits or perks available.
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default BenefitTiles;
